export enum StoredValueActionEnum {
  store = "儲值",
  recycle = "回收",
}
